import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { userInfoEntity } from './user-info.models';
import { Action, createReducer, on } from '@ngrx/store';
import * as UserInfoActions from './user-info.actions';

export const USER_INFO_FEATURE_KEY = 'userInfo';

export interface UserInfoState extends EntityState<userInfoEntity> {
  userInfo: userInfoEntity | null;
  loaded: boolean;
  error?: string | null;
  isSetUserInfo?: boolean;
}

export const userInfoAdapter: EntityAdapter<userInfoEntity> = createEntityAdapter<userInfoEntity>();

export const initialUserInfoState: UserInfoState = userInfoAdapter.getInitialState({
  userInfo: null,
  loaded: true,
  error: null,
  isSetUserInfo: false,
});

const reducer = createReducer(
  initialUserInfoState,
  on(UserInfoActions.loadUserInfo, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(UserInfoActions.loadUserInfoSuccess, (state, { userInfo }) => ({
    ...state,
    userInfo: userInfo,
    loaded: true,
    error: null,
  })),
  on(UserInfoActions.loadUserInfoFailure, (state, { error }) => ({
    ...state,
    loaded: true,
    error: error,
  })),
  on(UserInfoActions.setUserInfo, (state, { isSet }) => ({
    ...state,
    isSetUserInfo: isSet,
  })),
  on(UserInfoActions.deleteLastViewedDocument, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(UserInfoActions.deleteLastViewedDocumentSuccess, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(UserInfoActions.deleteLastViewedDocumentFailure, (state, { error }) => ({
    ...state,
    loaded: true,
    error: error,
  }))
);

export function userInfoReducer(state: UserInfoState | undefined, action: Action) {
  return reducer(state, action);
}
